import { OAUTH_GENERIC_WAITING_SCREEN } from "../_utils/routes";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL = `${API_BASE_URL}/api/v1`;
const PLANNER_BASE_URL = process.env.REACT_APP_API_PLANNER_BASE_URL;
const POSTS_DOWNLOADER_BASE_URL = process.env.REACT_APP_POSTS_DOWNLOADER_BASE_URL;
const URL_TO_IMAGE_BASE_URL = process.env.REACT_APP_URL_TO_IMAGE_BASE_URL;

export const LOGIN_USER = `${BASE_URL}/auth/login/`;
export const REGISTER_USER = `${BASE_URL}/auth/registration/`;
export const CONFIRM_YOUR_EMAIL_ADDRESS = `${BASE_URL}/accounts/confirm-email/`;
export const VERIFY_EMAIL = `${BASE_URL}/auth/registration/verify-email/`;
export const CONFIRM_EMAIL_SCREEN = `${BASE_URL}/accounts/confirm-email/`;
export const STORIES = `${BASE_URL}/stories`;
export const STORIES_DETAIL = `${STORIES}/{0}`;
export const STORY_TO_TEMPLATE = `${STORIES}/{0}/template`;
export const CLONE_STORIES_DETAIL = `${STORIES}/{0}/clone`;
export const EXPORT_VIDEO = `${STORIES}/{0}/video`;
export const EXPORT_DESIGN = `${STORIES}/{0}/export`;
export const STORIES_FONTS_ENDPOINT = `${STORIES}/{0}/fonts`;
export const RESET_PASSWORD = `${BASE_URL}/auth/password/reset/`;
export const RESET_PASSWORD_CONFIRMATION = `${BASE_URL}/auth/password/reset/confirm/`;
export const SET_NEW_PASSWORD_VIA_INVITATION = `${BASE_URL}/invitations`;
export const CHECK_TASK_STATAUS = `${BASE_URL}/tasks/{0}`;
export const CHECK_GROUP_TASK_STATUS = `${BASE_URL}/group-status/{0}`;

export const FETCH_STORIES = `${BASE_URL}/search/designs`;

export const GROUP_BY_TEMPLATES = `${BASE_URL}/search/templates`;
export const GROUP_AND_SEARCH_EMPLATES = `${GROUP_BY_TEMPLATES}&search={0}`;
export const GROUP_BY_CATEGORIES = `${BASE_URL}/search/templates/groups?group_by=category&template={0}`;
export const SEARCH_IN_GROUPED_CATEGORIES = `${GROUP_BY_CATEGORIES}&search={0}`;
export const SEARCH_BY_TEMPLATE_TYPE = `${BASE_URL}/search/templates`;
export const SEARCH_PROJECT_FORMATS_ENDPOINT = `${BASE_URL}/formats?search={}`;

export const TEMPLATES_ENDPOINT = `${BASE_URL}/templates`;

/// Legacy template endpoints
export const FETCH_TEMPLATES = `${BASE_URL}/templates?template={0}&org={1}&category={2}`;
export const FETCH_TEMPLATE_TYPES = `${BASE_URL}/templates/types?template={0}`;
export const PUBLISH_TEMPLATE = `${BASE_URL}/templates/{}`;
export const CREATE_COMPONENT = `${BASE_URL}/layers/{}/component`;
export const CLONE_LAYERS_ENDPOINT = `${BASE_URL}/layers/clone`;
export const CLONE_TEMPLATE = `${BASE_URL}/templates/{0}/clone`;
export const FETCH_CATEGORIES = `${BASE_URL}/categories?type={0}`;
export const FETCH_STORY_PAGES = `${BASE_URL}/stories/{0}/pages`;
export const PAGES = "/pages";

export const FETCH_TEXT_BLOCKS = `${SEARCH_BY_TEMPLATE_TYPE}?template=text`;

export const ASSETS_ENDPOINT = `${BASE_URL}/assets`;
export const ASSETS_SEARCH_ENDPOINT = `${BASE_URL}/search/assets`;
export const EFFECTS_ENDPOINT = `${BASE_URL}/effects?mime=1`;
export const DELETE_ASSET_ENDPOINT = `${ASSETS_ENDPOINT}/{0}`;
export const DELETE_TEMPLATE_ENDPOINT = `${TEMPLATES_ENDPOINT}/{0}`;
export const GRADIENTS_ENDPOINT = `${BASE_URL}/effects?mime=7`;

//// this is the link to be clicked from email :
// https://celeryhq.herokuapp.com/accounts/confirm-email/OA:1jG5uF:x-dVXy2QueVNzRw0YByF82x-AUA/

const SOCKET_BASE_URL = process.env.REACT_APP_SOCKET_BASE_URL;
export const WEBSOCKETS_ENDPOINT = `${SOCKET_BASE_URL}/ws/studio/{0}/?token={1}`;
export const WEBSOCKETS_WRITER_ENDPOINT = `${SOCKET_BASE_URL}/ws/writer/{0}/?token={1}`;
export const WEBSOCKETS_USER_NOTIFICATIONS_ENDPOINT = `${SOCKET_BASE_URL}/ws/user/{0}/?token={1}`;
export const WEBSOCKETS_NOTIFICATIONS_ENDPOINT = `${SOCKET_BASE_URL}/ws/user/{0}/?token={1}`;

export const GET_S3_SIGNED_URL_ENDPOINT = `${BASE_URL}/assets/sign`;
export const FONTS_ENDPOINT = `${BASE_URL}/fonts`;
export const DELETE_FONTS_ENDPOINT = `${BASE_URL}/fonts/{0}`;
export const GOOGLE_FONTS_ENDPOINT = `https://www.googleapis.com/webfonts/v1/webfonts?key=${process.env.REACT_APP_GOOGLE_FONTS_API}`;
// GOOGLE CLIENT ID:
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const LOGIN_WITH_GOOGLE = `${BASE_URL}/auth/google/`;

// Partner APIs
export const GENERIC_APP_CONNECT = `${BASE_URL}/partners/generic-app/connect`;
export const CONNECTED_ACCOUNTS = `${BASE_URL}/social/accounts/`;
export const CONNECTED_APPS = `${BASE_URL}/partners`;
export const LOGIN_WITH_SHOPIFY = `${BASE_URL}/auth/shopify/?shop={}`;
export const CONNECT_WITH_SHOPIFY = `${BASE_URL}/auth/shopify/connect/?shop={}`;
export const SHOPIFY_CLIENT_ID = process.env.REACT_APP_SHOPIFY_CLIENT_ID;
export const SEARCH_SHOPIFY = `${BASE_URL}/partners/integrations/shopify_app/fetch-products`;
export const SEARCH_GOOGLE_DRIVE = `${BASE_URL}/partners/integrations/google_drive/images-list`;
export const GENERIC_IMAGE_DOWNLOAD = `${BASE_URL}/partners/generic-file-download`;
const GENERIC_PROXY_ENDPOINT = `${BASE_URL}/partners/proxy`;
export const PUBLISH_MEDIA_URL = `${BASE_URL}/partners/publish-media`;
export const DISCONNECT_PARTNER_ENDPOINT = `${BASE_URL}/partners/{0}`;

export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;
export const OAUTH_CALLBACK_URL = `${DOMAIN_NAME}/shopify/callback`;
export const SHOPIFY_AUTH_URL = `https://{0}/admin/oauth/authorize`;
export const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
export const OAUTH_GENERIC_URL = `${DOMAIN_NAME}${OAUTH_GENERIC_WAITING_SCREEN}`;
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const INSTAGRAM_APP_ID = process.env.REACT_APP_INSTAGRAM_APP_ID;
export const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
export const PINTEREST_APP_ID = process.env.REACT_APP_PINTEREST_APP_ID;
export const TIKTOK_APP_ID = process.env.REACT_APP_TIKTOK_APP_ID;
export const OAUTH_PINTEREST_URL = "https://www.pinterest.com/oauth/";
export const OAUTH_TIKTOK_URL = "https://open-api.tiktok.com/platform/oauth/connect/";
export const OAUTH_FACEBOOK_URL = "https://www.facebook.com/v13.0/dialog/oauth";
export const OAUTH_INSTAGRAM_URL = " https://api.instagram.com/oauth/authorize/";
export const OAUTH_LINKEDIN_URL = "https://www.linkedin.com/oauth/v2/authorization";
export const OAUTH_TWITTER_REQUEST = `${PLANNER_BASE_URL}/auth/twitter/request`;
export const OAUTH_GOOGLE_LIST_LOCATIONS = `${PLANNER_BASE_URL}/auth/google/oauth2callback`;
export const OAUTH_PINTEREST_LIST_BOARDS = `${PLANNER_BASE_URL}/auth/pinterest/oauth2callback`;
export const OAUTH_FACEBOOK_LIST_PAGES = `${PLANNER_BASE_URL}/auth/facebook/oauth2callback?type=page`;
export const OAUTH_FACEBOOK_LIST_GROUPS = `${PLANNER_BASE_URL}/auth/facebook/oauth2callback?type=group`;
export const OAUTH_INSTAGRAM_LIST_BUSINESS_ACCOUNTS = `${PLANNER_BASE_URL}/auth/facebook/oauth2callback?type=instagramBusiness`;
export const OAUTH_LINKEDIN_LIST_COMPANIES = `${PLANNER_BASE_URL}/auth/linkedin/oauth2callback?type=organization`;
export const OAUTH_LINKEDIN_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/auth/linkedin/oauth2callback`;
export const OAUTH_TWITTER_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/auth/twitter/oauth_callback`;
export const OAUTH_TIKTOK_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/auth/tiktok/oauth2callback`;
export const OAUTH_INSTAGRAM_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/auth/instagram/oauth2callback`;
export const OAUTH_YOUTUBE_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/auth/youtube/oauth2callback`;
export const OAUTH_ADD_CHILDREN_ACCOUNTS = `${PLANNER_BASE_URL}/social_account/addChildrenAccounts.json`;
export const OAUTH_ADD_MAIN_ACCOUNT = `${PLANNER_BASE_URL}/social_account/addMainAccount.json`;

// Third party end points
export const UNSPLASH_KEY = process.env.REACT_APP_UNSPLASH_KEY;
export const GIPHY_KEY = process.env.REACT_APP_GIPHY_KEY;
export const PIXABAY_KEY = process.env.REACT_APP_PIXABAY;
export const GETTY_KEY = process.env.REACT_APP_GETTY_API_KEY;
export const PEXELS_CLIENT_ID = process.env.REACT_APP_PEXELS_CLIENT_ID;
export const BRANDFETCH_API_KEY = process.env.REACT_APP_BRANDFETCH_API_KEY;
export const GIPHY_SEARCH_ENDPOINT = `https://api.giphy.com/v1/stickers/search?api_key=${GIPHY_KEY}`;
export const GIPHY_TRENDING_ENDPOINT = `https://api.giphy.com/v1/stickers/trending?api_key=${GIPHY_KEY}`;
export const PIXABAY_VIDEO_ENDPOINT = `https://pixabay.com/api/videos/?key=${PIXABAY_KEY}`;
export const PIXABAY_VIDEO_COVER_ENDPOINT = `https://i.vimeocdn.com/video/{0}_{1}.jpg`;
export const PIXABAY_IMAGES_ENDPOINT = `https://pixabay.com/api/?key=${PIXABAY_KEY}`;
export const FETCH_IMAGES_ENDPOINT = `https://api.unsplash.com/photos/?client_id=${UNSPLASH_KEY}`;
export const STORYBLOCK_VIDEOS_FETCH = `${GENERIC_PROXY_ENDPOINT}/storyblocks_video/api/v2/videos/search`;
export const STORYBLOCK_IMAGES_FETCH = `${GENERIC_PROXY_ENDPOINT}/storyblocks_graphic/api/v2/images/search`;
export const STORYBLOCK_MUSIC_COLLECTIONS_FETCH = `${GENERIC_PROXY_ENDPOINT}/storyblocks_audio/api/v2/audio/stock-item/categories`;
export const STORYBLOCK_MUSIC_SEARCH = `${GENERIC_PROXY_ENDPOINT}/storyblocks_audio/api/v2/audio/search`;

export const SEARCH_IMAGES_ENDPOINT = `https://api.unsplash.com/search/photos/?client_id=${UNSPLASH_KEY}`;
export const DOWNLOAD_UNSPLASH_IMAGE_ENDPOINT = `{}&client_id=${UNSPLASH_KEY}`;

export const REMOVE_IMAGE_BACKGROUND = `${BASE_URL}/partners/background-remover`;

export const FETCH_IMAGES_ENDPOINT_PEXELS =
  "https://api.pexels.com/v1/curated/";
export const SEARCH_IMAGES_ENDPOINT_PEXELS =
  "https://api.pexels.com/v1/search/";
export const FETCH_VIDEOS_ENDPOINT_PEXELS = "https://api.pexels.com/videos/";

export const ICONS_ENDPOINT_FLATICON = `${GENERIC_PROXY_ENDPOINT}/flaticon`;
export const ICONS_SEARCH_ENDPOINT_FLATICON =
  ICONS_ENDPOINT_FLATICON + "/search/icons";
export const ICONS_ENDPOINT_BRANDFETCH = "https://api.brandfetch.io/v1/logo";
export const ICONS_ENDPOINT_CLEARBIT =
  "https://autocomplete.clearbit.com/v1/companies/suggest"; //?query=shopify
export const BRANDFETCH_LICENSE_AGREEMENT = "https://brandfetch.io/terms";

export const SHUTTERSTOCK_SEARCH_IMAGES_ENDPOINT =
  "https://api.shutterstock.com/v2/images/search?category=random&sort=popular";

export const BRANDFETCH_DATA = "https://api.brandfetch.io/v1/company";

export const ICONS_ENDPOINT_ICONS8 = `${GENERIC_PROXY_ENDPOINT}/icons8_icon`;
export const ICONS_ENDPOINT_NOUN_PROJECT = `${GENERIC_PROXY_ENDPOINT}/noun_project`;
export const FETCH_RECENTS = `${BASE_URL}/search/recents`;

// User management
export const WORKSPACES = `${BASE_URL}/orgs`;
export const DELETE_MEMBER = `${BASE_URL}/orgs/{}/members/{}`;
export const BULK_INVITE = `${BASE_URL}/orgs/{}/members/add`;

// Verify membership
export const INVITATIONS = `${BASE_URL}/invitations/{}/`;

export const GET_USER_INFO = `${BASE_URL}/auth/user/`;
export const CHANGE_PASSWORD = `${BASE_URL}/auth/password/change/`;

// Manage teams
export const SHOW_MY_TEAM_MEMBERS = `${BASE_URL}/orgs/`; //orgs/25/members
export const ADD_NEW_TEAM_MEMBER = `${BASE_URL}/orgs/`; //orgs/25/members

// Workspace Settings
export const UPDATE_WORKSPACE = `${BASE_URL}/orgs/{0}`;
export const UPDATE_WORKSPACE_USER_ROLE = `${BASE_URL}/orgs/{}/members/{}/update_role`;

// BrandKit endpoints
export const LIST_BRANDKITS = `${BASE_URL}/brandkit`;
export const CREATE_BRANDKIT = `${BASE_URL}/brandkit`;
export const GET_BRANDKIT_BY_ID = `${BASE_URL}/brandkit/{}`;
export const DELETE_BRANDKIT = `${BASE_URL}/brandkit/{}`;
export const UPDATE_BRANDKIT = `${BASE_URL}/brandkit/{}`;
export const LIST_BRANDKIT_LOGOS = `${BASE_URL}/brandkit/{}/logos`;
export const CREATE_BRANDKIT_LOGOS = `${BASE_URL}/brandkit/{}/logos`;
export const DELETE_BRANDKIT_LOGO = `${BASE_URL}/brandkit/{0}/logos/{1}`;
export const LIST_BRANDKIT_COLOR_PALLETE = `${BASE_URL}/brandkit/{}/palette`;
export const CREATE_BRANDKIT_COLOR_PALLETE = `${BASE_URL}/brandkit/{}/palette`;
export const UPDATE_BRANDKIT_COLOR_PALETTE = `${BASE_URL}/brandkit/{0}/palette/{1}`;

// Comments API
export const COMMENTS_ENDPOINT = `${BASE_URL}/comments`;
export const COMMENTS_PUBLIC_ENDPOINT = `${BASE_URL}/public-comments`;

// Guided tours
export const GENERATE_ASSETS = `${TEMPLATES_ENDPOINT}/{}/generate`;

// Proxy loading
export const PROXY_IMAGES = `${API_BASE_URL}/proxy?url=`;

// Folders API
export const FOLDERS_ENDPOINT = `${BASE_URL}/search/folders`;
export const CREATE_FOLDER_ENDPOINT = `${BASE_URL}/folders`;
export const FOLDER_OPERATIONS_ENDPOINT = `${BASE_URL}/folders/{0}`;
export const ADD_TO_FOLDER_ENDPOINT = `${FOLDER_OPERATIONS_ENDPOINT}/add_contents`;
export const FOLDER_CONTENTS_ENDPOINT = `${BASE_URL}/search/folders/{0}?org={1}&page={2}`;
export const REMOVE_FROM_FOLDER_ENDPOINT = `${FOLDER_OPERATIONS_ENDPOINT}/remove_contents`;

// Social share APIs
export const GET_INSTAGRAM_BUSINESS_ACCOUNTS = `${BASE_URL}/partners/integrations/instagram_business/list-accounts`;
export const PUBLISH_INSTAGRAM_POST = `${BASE_URL}/partners/integrations/instagram_business/publish-content`;

// AI
export const AI_ENDPOINT = `${BASE_URL}/writer`;
export const LAST_RUN = `${BASE_URL}/writer/last?prompt={}`;
export const FIND_DOMAIN = `${BASE_URL}/writer/find`;
export const COPIES_ENDPOINT = `${BASE_URL}/copy/{}`;

export const SAVED_COPIES = `${BASE_URL}/copy`;
export const GET_ALL_COPIES = `${BASE_URL}/last`;

// Formats
export const FETCH_FORMATS = `${BASE_URL}/formats?category={}`;
export const FILTER_FORMATS_BY_TITLE = `${BASE_URL}/formats?category__title={}`;

// Documents
export const DOCUMENTS_ENDPOINT = `${BASE_URL}/documents`;
export const DOCUMENTS_PLAGIARISM_ENDPOINT = `${BASE_URL}/documents/plagiarism`;
export const NEW_DOCUMENTS_ENDPOINT = `${BASE_URL}/documents/new`;
export const DOCUMENT_DETAILS = `${BASE_URL}/documents/{0}`;
export const MAGIC_ENDPOINT = `${BASE_URL}/documents/{}/generate`;
export const MAGIC_DESIGN = `${BASE_URL}/documents/{}/design`;
export const DELETE_DOCUMENTS_ENDPOINT = `${DOCUMENTS_ENDPOINT}/{0}`;
export const FAVORITE_COPIES = `${BASE_URL}/copy?status=1`;
export const SEARCH_DOCUMENTS_ENDPOINT = `${BASE_URL}/search/documents`;

export const FILTER_TEMPLATES_BY_CATEGORY_ENDPOINT = `${BASE_URL}/search/templates?template=template&format_id={0}&category_id={1}`;

// Billing and payment
export const ALL_SUBSCRIPTION_PLANS_ENDPOINT = `${BASE_URL}/payments/prices`;
export const SUBSCRIBED_PLAN_ENDPOINT = `${BASE_URL}/payments/subscription`;
export const SUBSCRIPTION_PAYMENT_HISTORY_ENDPOINT = `${BASE_URL}/payments/history`;
export const SUBSCRIPTION_ENDPOINT = `${BASE_URL}/payments/subscription`;
export const BILLING_PLAN_FEATURES_ENDPOINT = `${BASE_URL}/payments/features`;
export const BILLING_ORG_FEATURES_ENDPOINT = `${BASE_URL}/payments/org_features`;
export const CANCEL_SUBSCRIPTION_ENDPOINT = `${BASE_URL}/payments/cancel_subscription/{}`;
export const CREATE_CHECKOUT_SESSION_ENDPOINT = `${BASE_URL}/payments/checkout_session`;
export const CREATE_UPDATE_PAYMENT_METHOD_CHECKOUT_SESSION_ENDPOINT = `${BASE_URL}/payments/change_card_checkout_session`;
export const QUOTA_USAGES_ENDPOINT = `${BASE_URL}/payments/quota-usage`;
export const UPDATE_SUBSCRIPTION_SEATS_QUANTITY = `${BASE_URL}/payments/subscription/member/count`;
export const REMOVE_UPCOMING_PAYMENT_PHASE = `${BASE_URL}/payments/subscription/remove/phase`;
export const GET_BRAINTREE_CLIENT_TOKEN_ENDPOINT = `${BASE_URL}/payments/bt/client-token`;
export const BRAINTREE_COMPLETE_CHECKOUT_ENDPOINT = `${BASE_URL}/payments/bt/complete_checkout`;
export const ADD_SUBSCRIPTION_TO_CART = `${BASE_URL}/payments/cart/add_subscription`;

// Deals
export const SUMO_DEAL_ENDPOINT = `${BASE_URL}/sumo/{0}`;
export const SUMO_ACTIVATE_ENDPOINT = `${BASE_URL}/sumo/{0}/activate`;
export const SUMO_ASSOCIATE_ENDPOINT = `${BASE_URL}/sumo/{0}/associate`;

// Social accounts
export const SOCIAL_ACCOUNT_DISCONNECT = `${PLANNER_BASE_URL}/social_account/delete.json`;
export const SOCIAL_ACCOUNTS_GET_ADDED = `${PLANNER_BASE_URL}/social_account/getAccounts.json`;
export const SOCIAL_ACCOUNTS_HAS_ACCOUNTS = `${PLANNER_BASE_URL}/social_account/hasAccounts.json`;
export const SOCIAL_ACCOUNTS_REFRESH_ACCOUNT_DATA = `${PLANNER_BASE_URL}/social_account/refreshData.json`;
export const SOCIAL_ACCOUNT_ADD_TIMESLOTS = `${PLANNER_BASE_URL}/settings/addQueueTime.json`;
export const SOCIAL_ACCOUNT_SHUFFLE_QUEUE = `${PLANNER_BASE_URL}/social_account/shuffleQueue.json`;
export const SOCIAL_ACCOUNT_CLEAR_QUEUE = `${PLANNER_BASE_URL}/social_account/clearQueue.json`;
export const SOCIAL_ACCOUNT_GET_TIMESLOTS = `${PLANNER_BASE_URL}/settings/getQueueTimepoints/{0}.json`;
export const SOCIAL_ACCOUNT_DELETE_TIMESLOTS = `${PLANNER_BASE_URL}/settings/deleteTime.json`;
export const SOCIAL_ACCOUNT_UPDATE_UTM = `${PLANNER_BASE_URL}/settings/updateUtm.json`;
export const SOCIAL_ACCOUNT_GET_UTM = `${PLANNER_BASE_URL}/settings/getUtm/{0}.json`;
export const SOCIAL_ACCOUNT_GET_SHORTLINKS = `${PLANNER_BASE_URL}/settings/getShortenerSettings/{0}.json`;
export const SOCIAL_ACCOUNT_SET_SHORTLINKS = `${PLANNER_BASE_URL}/settings/updateShortenerSettings.json`;
export const SOCIAL_ACCOUNT_GET_PAGES_FOR_GROUP = `${PLANNER_BASE_URL}/settings/getPagesForGroup/{0}.json`;
export const SOCIAL_ACCOUNT_SET_PUBLISH_BY = `${PLANNER_BASE_URL}/settings/savePublishBy.json`;
export const SOCIAL_ACCOUNT_GET_NOTIFICATION_SETTINGS = `${PLANNER_BASE_URL}/settings/getNotificationsSettings.json`;
export const SOCIAL_ACCOUNT_SET_NOTIFICATION_SETTINGS = `${PLANNER_BASE_URL}/settings/setNotification.json`;

// Post planner
export const PLANNER_ALL_CHANNELS_ENDPOINT = `${BASE_URL}/planner/channels`;
export const PLANNER_CHANNEL_ENDPOINT = `${BASE_URL}/planner/channels/{0}`;
export const PLANNER_SLOTS_PER_CHANNEL_ENDPOINT = `${BASE_URL}/planner/channels/{0}/slots`;
export const PLANNER_ALL_SLOTS_ENDPOINT = `${BASE_URL}/planner/channels/{0}/slots_sequence`;
export const PLANNER_SLOT_ENDPOINT = `${BASE_URL}/planner/channels/{0}/slots/{1}`;

export const PLANNER_GET_POSTS_CALENDAR_ENDPOINT = `${PLANNER_BASE_URL}/calendar/get_posts.json`;
export const PLANNER_GET_POSTS_LIST_ENDPOINT = `${PLANNER_BASE_URL}/post_date_schedulers/getTimelineList/{0}.json?accountIds={1}&perPage={2}&category={3}&tz={4}&search={5}&query={6}"`;
export const PLANNER_GET_POST_DETAILS_ENDPOINT = `${PLANNER_BASE_URL}/post_date_schedulers/getPostDetailsData/{0}.json`;
export const PLANNER_MOVE_POSTS_ENDPOINT = `${PLANNER_BASE_URL}/calendar/update_post_time.json`;
export const PLANNER_SWAP_POSTS_ENDPOINT = `${PLANNER_BASE_URL}/calendar/swap_posts_time.json`;
export const PLANNER_DELETE_POST_ENDPOINT = `${PLANNER_BASE_URL}/post_date_schedulers/delete.json`;
export const PLANNER_MULTIPLY_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/multiply.json`;
export const PLANNER_MULTIPLY_REMOVE_COPIES_ENDPOINT = `${PLANNER_BASE_URL}/post-action/multiply-remove-copies.json`;
export const PLANNER_MULTIPLY_LIST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/multiply-list.json`;
export const PLANNER_SAVE_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/save.json`;
export const PLANNER_ADD_SCHEDULE_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/add-schedule.json`;
export const PLANNER_ADD_BUFFER_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/add-buffer.json`;
export const PLANNER_ADD_ASYNC_PUBLISH_NOW_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/async-publish-now.json`;
export const PLANNER_ASYNC_PUBLISH_NOW_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/publish-now-by-id.json`;
export const PLANNER_ADD_ASYNC_STATUS_POST_ENDPOINT = `${PLANNER_BASE_URL}/post-action/async-status.json`;
export const PLANNER_SAVE_DRAFT_ENDPOINT = `${PLANNER_BASE_URL}/post-action/save-draft.json`;
export const PLANNER_ADD_DRAFT_ENDPOINT = `${PLANNER_BASE_URL}/post-action/add-draft.json`;
export const PLANNER_ADD_FOR_APPROVAL_DRAFT_ENDPOINT = `${PLANNER_BASE_URL}/post-action/add-for-approval-draft.json`;
export const PLANNER_GET_DRAFTS_ENDPOINT = `${PLANNER_BASE_URL}/draft/getListByAccounts.json`;
export const PLANNER_UPDATE_WORKFLOW_TYPE_ENDPOINT = `${PLANNER_BASE_URL}/draft/changeWorkflowType.json`;
export const PLANNER_DELETE_DRAFT_ENDPOINT = `${PLANNER_BASE_URL}/draft/delete.json`;
export const PLANNER_GET_DRAFT_ENDPOINT = `${PLANNER_BASE_URL}/draft/getPost/{0}.json`;
export const PLANNER_GET_DRAFT_HISTORY_ENDPOINT = `${PLANNER_BASE_URL}/draft/getVersionsList/{0}.json`;
export const PLANNER_SET_DRAFT_STATUS = `${PLANNER_BASE_URL}/draft/transition.json`;
export const PLANNER_GET_EVENTS_ENDPOINT = `${PLANNER_BASE_URL}/custom_calendar_item/get_by_range.json`;
export const PLANNER_GET_EVENTS_CATEGORIES_ENDPOINT = `${PLANNER_BASE_URL}/custom_calendar_item/getCategories.json`;
export const PLANNER_APPROVAL_PACKAGE_APPROVE = `${PLANNER_BASE_URL}/review/approve.json`;
export const PLANNER_APPROVAL_PACKAGE_REJECT = `${PLANNER_BASE_URL}/review/reject.json`;
export const PLANNER_GET_APPROVAL_PACKAGE = `${PLANNER_BASE_URL}/review/browse/{0}.json`;
export const PLANNER_GET_APPROVAL_PACKAGES = `${PLANNER_BASE_URL}/review/getList.json?status=new`;
export const PLANNER_CREATE_APPROVAL_PACKAGE = `${PLANNER_BASE_URL}/review/createReviewPackage.json`;
export const PLANNER_UPDATE_APPROVAL_PACKAGE = `${PLANNER_BASE_URL}/review/updateReviewPackage.json`;
export const PLANNER_GENERATE_REPORT_ENDPOINT = `${POSTS_DOWNLOADER_BASE_URL}/download/posts`;

export const PLANNER_GET_SNIPPETS_ENDPOINT = `${PLANNER_BASE_URL}/snippet/list.json`;
export const PLANNER_ADD_SNIPPET_ENDPOINT = `${PLANNER_BASE_URL}/snippet/add.json`;
export const PLANNER_REMOVE_SNIPPET_ENDPOINT = `${PLANNER_BASE_URL}/snippet/remove.json`;
export const PLANNER_EDIT_SNIPPET_ENDPOINT = `${PLANNER_BASE_URL}/snippet/edit.json`;
export const PLANNER_USED_SNIPPET_ENDPOINT = `${PLANNER_BASE_URL}/snippet/used.json`;

export const PLANNER_SCRAPER_FETCH_ENDPOINT = `${PLANNER_BASE_URL}/scraper.json?url={0}`;

export const PLANNER_MENTIONS_FETCH_ENDPOINT = `${PLANNER_BASE_URL}/post_date_schedulers/mention.json?types={0}&q={1}`;
export const PLANNER_TWITTER_MENTIONS_FETCH_ENDPOINT = `https://twitter.com/i/search/typeahead.json?count=10&filters=true&result_type=users&src=compose&q={0}`;

export const PLANNER_MULTIPART_UPLOAD_ENDPOINT = `${PLANNER_BASE_URL}/upload_file.json`;
export const PLANNER_THUMBNAIL_UPLOAD_ENDPOINT = `${PLANNER_BASE_URL}/upload_file/thumbnail.json`;

export const PLANNER_GET_AVAILABLE_POSTS_QUOTA = `${PLANNER_BASE_URL}/settings/getAvailablePostsQuota.json`;

// Planner analytics
export const ANALYTICS_ENABLE = `${PLANNER_BASE_URL}/analytics/enable.json`;
export const ANALYTICS_STATUS = `${PLANNER_BASE_URL}/analytics/status.json`;
export const ANALYTICS_RANGE_DATA = `${PLANNER_BASE_URL}/analytics/rangeData.json`;
export const ANALYTICS_RANGE_POSTS_DATA = `${PLANNER_BASE_URL}/analytics/rangePostsData.json`;
export const ANALYTICS_REPORT_ENDPOINT = `${URL_TO_IMAGE_BASE_URL}/download/url-to-image`;
export const ANALYTICS_REPORT_PREVIEW = `${DOMAIN_NAME}/analytics/generate-report`;

// Roles
export const ROLES_ENDPOINT = `${BASE_URL}/roles`;
export const UPDATE_USER_ROLES = `${BASE_URL}/user-roles/change_role`;
export const GET_WORKSPACE_MEMBERS = `${BASE_URL}/user-roles`; // It exclude guests;

// Sharing
export const SHARED_ITEMS_ENDPOINT = `${BASE_URL}/share-content`;
export const SHARED_ITEM_USER_ENDPOINT = `${BASE_URL}/share-content/{0}/users/{1}`;
export const GET_ORG_GUESTS = `${BASE_URL}/share-content/members`;

// template search suggestions
export const TEMPLATES_SEARCH_TAGS_SUGGESTIONS_ENDPOINT = `${BASE_URL}/search/template-suggest/suggest?tag_suggest__completion={0}`;

// bulk create
export const BULK_CREATE_ENDPOINT = `${BASE_URL}/stories`;

// Notifications
export const GET_NOTIFICATIONS_ENDPOINT = `${BASE_URL}/notifications?workspace={0}&page={1}`;
export const DELETE_NOTIFICATION_ENDPOINT = `${BASE_URL}/notifications/{0}`;
export const READ_NOTIFICATION_ENDPOINT = `${BASE_URL}/notifications/mark_read`;
export const CLEAR_NOTIFICATION_ENDPOINT = `${BASE_URL}/notifications/clear_all`;
export const READ_ALL_NOTIFICATION_ENDPOINT = `${BASE_URL}/notifications/read_all`;

// Quick Tools
export const SIGNED_URL = `${BASE_URL}/signed-image`;
export const GROWTH_TOOLS_ENDPOINT = `${BASE_URL}/growth-tools`;
export const VIDEO_GROWTH_TOOLS = `${BASE_URL}/video-growth-tools`;
export const CHECK_TASK_STATUS = `${BASE_URL}/tasks/{0}`;
export const OPEN_IN_EDITOR = `${BASE_URL}/open-in-editor`

export const EXPORT_LIBRARY_ENDPOINT = `${BASE_URL}/export-lib`;

export const SNAPSHOT_MAKER_GET_TWEET_DATA = `${PLANNER_BASE_URL}/twitter/tweet.json?tweet_id={0}`;
export const SNAPSHOT_MAKER_GENERATE_IMAGE = `${URL_TO_IMAGE_BASE_URL}/download/url-to-image`;
